module.exports = "/images/sophia-stories.png?2249cec564eaaa5ad2f913fbda5f4382";